import { useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";

function App() {
  const [data, setData] = useState({ data1: [], data2: [], data3: [] });
  const [expanded, setExpanded] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [metrics, setMetrics] = useState({
    data1: { last7Days: 0, thisMonth: 0, lastMonth: 0 },
    data2: { last7Days: 0, thisMonth: 0, lastMonth: 0 },
    data3: { last7Days: 0, thisMonth: 0, lastMonth: 0 }
  });

  useEffect(() => {
    const storedLoginState = localStorage.getItem("isLoggedIn");
    if (storedLoginState === "true") {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLoggedIn(true);
        localStorage.setItem("isLoggedIn", "true");
      } else {
        setIsLoggedIn(false);
        localStorage.removeItem("isLoggedIn");
      }
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      fetch("https://admin-850861419930.us-central1.run.app/data")
        .then((res) => res.json())
        .then((fetchedData) => {
          setData(fetchedData);
          calculateMetrics(fetchedData);
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, [isLoggedIn]);

  const calculateMetrics = (fetchedData) => {
    const calculateForDataset = (readings) => {
      const now = new Date();
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      
      const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
      
      let last7DaysCount = 0;
      let thisMonthCount = 0;
      let lastMonthCount = 0;
      
      readings.forEach(item => {
        if (item.timestamp && item.timestamp._seconds) {
          const itemDate = new Date(item.timestamp._seconds * 1000);
          
          if (itemDate >= sevenDaysAgo) {
            last7DaysCount++;
          }
          
          if (itemDate >= thisMonthStart && itemDate <= now) {
            thisMonthCount++;
          }
          
          if (itemDate >= lastMonthStart && itemDate <= lastMonthEnd) {
            lastMonthCount++;
          }
        }
      });
      
      return {
        last7Days: last7DaysCount,
        thisMonth: thisMonthCount,
        lastMonth: lastMonthCount
      };
    };
    
    setMetrics({
      data1: calculateForDataset(fetchedData.data1),
      data2: calculateForDataset(fetchedData.data2),
      data3: calculateForDataset(fetchedData.data3)
    });
  };

  const handleLogout = () => {
    signOut(auth);
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn");
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const renderDataList = (data, title, sectionMetrics) => (
    <div style={{ marginBottom: "16px" }}>
      <div 
        onClick={() => setExpanded((prev) => ({ ...prev, [title]: !prev[title] }))} 
        style={{ 
          cursor: "pointer", 
          background: "#f5f5f5", 
          padding: "12px 16px", 
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "14px",
          fontWeight: "500",
          border: "1px solid #e0e0e0"
        }}
      >
        <span>{title}</span>
        <span style={{ fontSize: "12px", color: "#666" }}>
          {expanded[title] ? "▼" : "▶"}
        </span>
      </div>
      
      <div style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(3, 1fr)", 
        gap: "6px", 
        marginTop: "8px",
        padding: "0 4px"
      }}>
        <div style={{ 
          background: "#f8f9fa", 
          padding: "8px", 
          borderRadius: "6px", 
          textAlign: "center",
          border: "1px solid #e9ecef"
        }}>
          <div style={{ fontSize: "10px", color: "#6c757d", marginBottom: "2px", fontWeight: "500" }}>
            7 Days
          </div>
          <div style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
            {sectionMetrics.last7Days}
          </div>
        </div>
        <div style={{ 
          background: "#f8f9fa", 
          padding: "8px", 
          borderRadius: "6px", 
          textAlign: "center",
          border: "1px solid #e9ecef"
        }}>
          <div style={{ fontSize: "10px", color: "#6c757d", marginBottom: "2px", fontWeight: "500" }}>
            This Month
          </div>
          <div style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
            {sectionMetrics.thisMonth}
          </div>
        </div>
        <div style={{ 
          background: "#f8f9fa", 
          padding: "8px", 
          borderRadius: "6px", 
          textAlign: "center",
          border: "1px solid #e9ecef"
        }}>
          <div style={{ fontSize: "10px", color: "#6c757d", marginBottom: "2px", fontWeight: "500" }}>
            Last Month
          </div>
          <div style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
            {sectionMetrics.lastMonth}
          </div>
        </div>
      </div>
      
      {expanded[title] && (
        <ul style={{ listStyleType: "none", padding: "8px 0", margin: 0 }}>
          {data.map((item) => (
            <li key={item.id} style={{ marginBottom: "8px" }}>
              <div
                onClick={() => setExpanded((prev) => ({ ...prev, [item.id]: !prev[item.id] }))}
                style={{
                  padding: "10px 12px",
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  background: "#fff",
                  cursor: "pointer",
                  fontSize: "13px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <span>
                  {item.timestamp && item.timestamp._seconds
                    ? new Date(item.timestamp._seconds * 1000).toLocaleDateString()
                    : "No valid timestamp"}
                </span>
                <span style={{ fontSize: "11px", color: "#999" }}>
                  {expanded[item.id] ? "▼" : "▶"}
                </span>
              </div>
              {expanded[item.id] && (
                <div
                  style={{
                    background: "#fafafa",
                    padding: "10px 12px",
                    borderRadius: "0 0 6px 6px",
                    marginTop: "-4px",
                    border: "1px solid #e8e8e8",
                    borderTop: "none",
                    fontSize: "12px",
                    wordBreak: "break-word"
                  }}
                >
                  <pre style={{ margin: 0, whiteSpace: "pre-wrap", fontFamily: "monospace", fontSize: "11px" }}>
                    {JSON.stringify(item, null, 2)}
                  </pre>
                  {item.image && (
                    <a 
                      href={item.image} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      style={{ 
                        color: "#007BFF", 
                        textDecoration: "none",
                        fontSize: "12px",
                        display: "inline-block",
                        marginTop: "8px"
                      }}
                    >
                      View Image →
                    </a>
                  )}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  if (!isLoggedIn) {
    return (
      <div style={{ 
        width: "100vw", 
        height: "100vh", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        background: "#f8f9fa", 
        padding: "16px"
      }}>
        <div style={{ 
          padding: "24px", 
          width: "100%", 
          maxWidth: "360px",
          background: "white", 
          borderRadius: "12px", 
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)" 
        }}>
          <h1 style={{ marginBottom: "24px", fontSize: "20px", fontWeight: "600", color: "#333" }}>
            Admin Login
          </h1>
          <form 
            onSubmit={(e) => { 
              e.preventDefault(); 
              signInWithEmailAndPassword(auth, email, password).catch(() => setError("Invalid credentials")); 
            }} 
            style={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              placeholder="Email" 
              required 
              style={{ 
                padding: "12px", 
                borderRadius: "8px", 
                border: "1px solid #ddd", 
                outline: "none",
                fontSize: "14px",
                transition: "border-color 0.2s"
              }} 
            />
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              placeholder="Password" 
              required 
              style={{ 
                padding: "12px", 
                borderRadius: "8px", 
                border: "1px solid #ddd", 
                outline: "none",
                fontSize: "14px",
                transition: "border-color 0.2s"
              }} 
            />
            {error && <p style={{ color: "#dc3545", fontSize: "13px", margin: "-8px 0 0 0" }}>{error}</p>}
            <button 
              type="submit" 
              style={{ 
                padding: "12px", 
                borderRadius: "8px", 
                background: "#007BFF", 
                color: "white", 
                border: "none", 
                fontSize: "15px", 
                fontWeight: "500",
                cursor: "pointer", 
                transition: "background 0.2s",
                marginTop: "8px"
              }}
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      maxWidth: "600px", 
      margin: "0 auto", 
      padding: "16px",
      background: "#fff",
      minHeight: "100vh"
    }}>
      <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center", 
        marginBottom: "20px",
        paddingBottom: "16px",
        borderBottom: "1px solid #f0f0f0"
      }}>
        <h1 style={{ 
          fontSize: "18px", 
          fontWeight: "600", 
          margin: 0, 
          color: "#333" 
        }}>
          Readings Dashboard
        </h1>
        <div style={{ display: "flex", gap: "8px" }}>
          <button 
            onClick={handleRefresh} 
            style={{ 
              padding: "8px 12px", 
              borderRadius: "6px", 
              background: "#007BFF", 
              color: "white", 
              border: "none", 
              fontSize: "13px", 
              cursor: "pointer",
              fontWeight: "500"
            }}
          >
            Refresh
          </button>
          <button 
            onClick={handleLogout} 
            style={{ 
              padding: "8px 12px", 
              borderRadius: "6px", 
              background: "#6c757d", 
              color: "white", 
              border: "none", 
              fontSize: "13px", 
              cursor: "pointer",
              fontWeight: "500"
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {renderDataList(data.data1, "SVMD_DEV", metrics.data1)}
      {renderDataList(data.data2, "SVMD_CFC", metrics.data2)}
      {renderDataList(data.data3, "SVMD_TEST", metrics.data3)}
    </div>
  );
}

export default App;